import { render, staticRenderFns } from "./TipoContatoCard.vue?vue&type=template&id=439cd7b5&scoped=true&"
import script from "./TipoContatoCard.vue?vue&type=script&lang=js&"
export * from "./TipoContatoCard.vue?vue&type=script&lang=js&"
import style0 from "./TipoContatoCard.vue?vue&type=style&index=0&id=439cd7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439cd7b5",
  null
  
)

export default component.exports